import script from "./super-admin.vue?vue&type=script&setup=true&lang=js"
export * from "./super-admin.vue?vue&type=script&setup=true&lang=js"

import "./super-admin.vue?vue&type=style&index=0&id=48f554d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f554d5"]])

export default __exports__